import { format } from 'date-fns';

function fromGlobalId(globalId) {
  if (!globalId) {
    return {
      id: globalId,
    };
  }

  try {
    const tmp = atob(globalId).split(':');
    return {
      type: tmp[0],
      id: tmp[1] || globalId,
    };
  } catch (e) {
    // safely ignore the error
    return globalId;
  }
}

function dateNormalDisplay(v) {
  if (!v) return '';
  if (typeof v === 'string') v = parseInt(v);
  return format(new Date(v), 'MMM Do, YYYY');
}

function composeIds(...ids) {
  return ids.join('_');
}

const REVIEW_STATUS = {
  DRAFT: 'DRAFT',
  DOING: 'DOING',
  FINISH: 'FINISH',
};

export default {
  fromGlobalId,
  dateNormalDisplay,
  composeIds,
  REVIEW_STATUS,
};
